import { render, staticRenderFns } from "./JDProductSalesTable.vue?vue&type=template&id=75462360&scoped=true&"
import script from "./JDProductSalesTable.vue?vue&type=script&lang=js&"
export * from "./JDProductSalesTable.vue?vue&type=script&lang=js&"
import style0 from "./JDProductSalesTable.vue?vue&type=style&index=0&id=75462360&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75462360",
  null
  
)

export default component.exports